module.exports = __webpack_public_path__ + "img/bc-esasfkari.957f45a4.png";